export default {
  Coke: 1,
  MountainDew: 2,
  Doritos: 3,
  Cheetos: 4,
  Berry: 5,
  SevenUp: 6,
};
